import { useMutation } from "@tanstack/react-query";

import { api } from "@/lib/api";

import type { MeetRoom } from "@/modules/meet/user/types";

export const useCreateCall = (conversationId: number) =>
  useMutation({
    mutationFn: () =>
      api
        .post<MeetRoom>(`/messenger/conversations/${conversationId}/call`)
        .then((r) => r.data),
  });
